import { React } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

import { ReactComponent as EmptySignSvg } from '../../../image/EmptySign.svg';

import NoticeInfo from './NoticeInfo';

const NoticeList = (props) => {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();
  const history = useHistory();

  function clickDetailsFn(index) {
    window.open('/notice/details/' + data[index].noticeId, '_blank');
  }

  return (
    <TopLevelWrapper isDark={isDark}>
      {
        data.length === 0 ?
          <EmptyWrapper>
            <StyledEmptySign />
            <EmptyText>{t('noticePage.noNotice')}</EmptyText>
          </EmptyWrapper>
          :
          <TotalView>
            {
              data.map((data, index) => (
                <NoticeInfo key={'GeneralNotice-' + index} data={data} index={index} clickFn={clickDetailsFn}/>
              ))
            }
          </TotalView>
      }
    </TopLevelWrapper>
  )
}

export default NoticeList;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 10px;
  margin-top: 10px;

  box-sizing: border-box;
  width: 1035px;
  height: 580px;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const TotalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 100%;
`;

const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  gap: 8px;
`;

const StyledEmptySign = styled(EmptySignSvg)`
  width: 148px;
  height: 62px;

  & > rect {
    fill: ${props => props.theme.buttonFill3};
  }

  & > path {
    fill: ${props => props.theme.white};
  }

  & > g rect {
    fill: ${props => props.theme.line};
  }
`;

const EmptyText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;
